import React from 'react';
import '../assets/Reports.css';

const DOMAIN_CONFIG = {
  BOOT:              { label: 'Boot KPIs',             unit: 's',    precision: 2 },
  REGISTRATION:      { label: 'Registration Failures',  unit: '%',    precision: 1 },
  PDN:               { label: 'PDN Failures',           unit: '%',    precision: 1 },
  MEMORY:            { label: 'Memory / Flash Usage',   unit: '%',    precision: 1 },
  DATASTALL:         { label: 'Data Stalls',            unit: '',     precision: 0 },
  SUBSYSTEM_RESTART: { label: 'MODEM Restarts',         unit: '',     precision: 0 },
  UPLINK:            { label: 'Uplink Throughput',      unit: ' Mbps', precision: 1 },
  DOWNLINK:          { label: 'Downlink Throughput',    unit: ' Mbps', precision: 1 },
};

function KpiCard({ domain, onDeviceClick }) {
  const [expanded, setExpanded] = React.useState(false);
  const config = DOMAIN_CONFIG[domain.domain] || { label: domain.displayName, unit: '', precision: 1 };
  const devices = domain.devices || [];
  const visible = expanded ? devices : devices.slice(0, 5);
  const status = (domain.status || 'OK').toLowerCase();

  return (
    <div className="fh-kpi-card">
      <div className={`fh-kpi-header fh-kpi-header--${status}`}>
        <div className="fh-kpi-title">
          <span className={`fh-status-dot fh-status-dot--${status}`} />
          <span>{config.label}</span>
        </div>
        <span className="fh-flagged-count">
          {domain.flaggedCount} device{domain.flaggedCount !== 1 ? 's' : ''} flagged
        </span>
      </div>

      {devices.length === 0 ? (
        <div className="fh-no-data">No flagged devices</div>
      ) : (
        <>
          <table className="fh-device-table">
            <thead>
              <tr>
                <th>Device</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {visible.map((d) => (
                <tr
                  key={d.deviceId}
                  className="fh-device-row"
                  onClick={() => onDeviceClick && onDeviceClick(d.deviceId)}
                >
                  <td>
                    <span className="fh-device-link">{d.deviceId}</span>
                  </td>
                  <td>
                    <span className="fh-metric-value">
                      {typeof d.metricValue === 'number'
                        ? d.metricValue.toFixed(config.precision)
                        : d.metricValue}
                      {config.unit}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {devices.length > 5 && (
            <button className="fh-view-all-btn" onClick={() => setExpanded(!expanded)}>
              {expanded
                ? `▲ Show less`
                : `▾ View all ${devices.length} devices`}
            </button>
          )}
        </>
      )}
    </div>
  );
}

function FleetHealthSection({ data, loading, error, onDeviceClick }) {
  const [collapsed, setCollapsed] = React.useState(false);

  const domains = data?.domains || [];

  return (
    <div className="fh-section">
      {/* Section header — matches existing Card.js style */}
      <div className="reports-card-header" onClick={() => setCollapsed(!collapsed)} style={{ cursor: 'pointer' }}>
        <h2>Fleet Health</h2>
        <span className="fh-collapse-icon" style={{ transform: collapsed ? 'rotate(-90deg)' : 'none' }}>▼</span>
      </div>

      {!collapsed && (
        <div className="reports-card-content">
          {loading && (
            <div className="fh-loading">Loading fleet health data…</div>
          )}

          {!loading && error && (
            <div className="fh-error">
              {error.message || 'Fleet health data unavailable for this time range.'}
            </div>
          )}

          {!loading && !error && domains.length === 0 && (
            <div className="fh-no-data">No fleet health data available.</div>
          )}

          {!loading && !error && domains.length > 0 && (
            <>
              {data?.fromDate && (
                <div className="fh-window-label">
                  Window: {data.fromDate} → {data.toDate}
                  {data.tag && data.tag !== 'all' && ` · Group: ${data.tag}`}
                </div>
              )}
              <div className="fh-grid">
                {domains.map((domain) => (
                  <KpiCard
                    key={domain.domain}
                    domain={domain}
                    onDeviceClick={onDeviceClick}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default FleetHealthSection;
